import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { SecurityEndpoint } from './SecurityEndpoint.service';
import { ApplicationVldDto } from '../models/ApplicationVld.model';
import { BusinessRuleMessage } from '../models/BusinessRuleMessage.model';
import { UserProfileDto } from '../models/UserProfile.model';
import { UserLoginDto } from '../models/UserLogin.model';
import { RoleVldDto } from '../models/RoleVld.model';
import { ConfigurationService } from './configuration.service';
import { MadiAuthenticationDto } from '../models/MadiAuthentication.model';
import { UserProfileRequestDto } from '../models/UserProfileRequest.model';
import { UserProfileTypeListItem } from '../models//UserProfileTypeListItem.model';
import { Actions } from '../models/RolePermissionVld.model';


@Injectable()

export class SecurityService {
  private currentUserProfileItemKey: string = "windowsUserProfile";
  private myAlbertaIdPropertiesKey: string = "madiProperties";
  private companyLoginKey: string = "airbCompanyLogin";
  private currentCompanyLoginContactKey: string = "airbCompanyLoginContact";

  currentUserProfile(): UserProfileDto {
    let userProfile: UserProfileDto = JSON.parse(localStorage.getItem(this.currentUserProfileItemKey));
   
    if (userProfile != null) {
      return userProfile;
    }

    return null;
  }

  userName(): string {
    let userProfile: UserProfileDto = this.currentUserProfile();
   
    if (userProfile != null) {
      if (this.configuration.getExternalWebsiteMode == "yes") {
        return userProfile.firstName + " " + userProfile.lastName;
      } else {
        return "GOA\\" + userProfile.adsUserName;
      }
      
    }

    return null;
  }

  externalUserId(): string {
    let userProfile: UserProfileDto = this.currentUserProfile();
   
    if (userProfile != null) {
      return userProfile.externalLoginId;

    }

    return null;
  }

  isAuthorized(): boolean {
    let userProfile: UserProfileDto = this.currentUserProfile();

    if (userProfile != null) {
      return true;
    }

    return false;
  }

  
  hasAdministratorRole(): boolean {
    let userProfile: UserProfileDto = this.currentUserProfile();
    ////console.log(userProfile);
    if (userProfile != null &&
      userProfile.accesses != undefined &&
      userProfile.accesses.length > 0 &&
      userProfile.accesses.findIndex(access => access.roleVldID === RoleVldDto.Type.DivisionAdministrator || access.roleVldID === RoleVldDto.Type.SubmissionDivisionAdministrator) >= 0) {
      return true;
    }

    return false;
  }

  hasAdministratorRoleByApp(appId: number): boolean {
    let userProfile: UserProfileDto = this.currentUserProfile();
    ////console.log(userProfile);

    var accesses = userProfile.accesses.filter(a => a.roleVld.applicationVldID == appId);

    if (userProfile != null &&
      accesses != undefined &&
      accesses.length > 0 &&
      accesses.findIndex(access => access.roleVldID === RoleVldDto.Type.DivisionAdministrator || access.roleVldID === RoleVldDto.Type.SubmissionDivisionAdministrator) >= 0) {
      return true;
    }

    return false;
  }

  hasDivisionReadOnlyRole(): boolean {
    let userProfile: UserProfileDto = this.currentUserProfile();
    ////console.log(userProfile);
    if (userProfile != null &&
      userProfile.accesses != undefined &&
      userProfile.accesses.length > 0 &&
      userProfile.accesses.findIndex(access => access.roleVldID === RoleVldDto.Type.DivisionReader) >= 0) {
      return true;
    }

    return false;
  }

  myAlbertaIdPersistentId(): string {
    let myAlbertaIdProperties: MadiAuthenticationDto = JSON.parse(localStorage.getItem(this.myAlbertaIdPropertiesKey));

    if (myAlbertaIdProperties != null && myAlbertaIdProperties.persistentId != null && myAlbertaIdProperties.persistentId != "") {
      return myAlbertaIdProperties.persistentId.toString();
    }

    return "";
  }

  myAlbertaIdFirstName(): string {
    let myAlbertaIdProperties: MadiAuthenticationDto = JSON.parse(localStorage.getItem(this.myAlbertaIdPropertiesKey));

    if (myAlbertaIdProperties != null && myAlbertaIdProperties.givenName != null && myAlbertaIdProperties.givenName != "") {
      return myAlbertaIdProperties.givenName.toString();
    }

    return "";
  }

  myAlbertaIdLastName(): string {
    let myAlbertaIdProperties: MadiAuthenticationDto = JSON.parse(localStorage.getItem(this.myAlbertaIdPropertiesKey));

    if (myAlbertaIdProperties != null && myAlbertaIdProperties.surName != null && myAlbertaIdProperties.surName != "") {
      return myAlbertaIdProperties.surName.toString();
    }

    return "";
  }

  myAlbertaIdEmail(): string {
    let myAlbertaIdProperties: MadiAuthenticationDto = JSON.parse(localStorage.getItem(this.myAlbertaIdPropertiesKey));

    if (myAlbertaIdProperties != null && myAlbertaIdProperties.emailAddress != null && myAlbertaIdProperties.emailAddress != "") {
      return myAlbertaIdProperties.emailAddress.toString();
    }

    return "";
  }

  async redirectToLogin(returnUrl: string) {
    // wait for the promise to resolve
    let redirectUrl = this.configuration.ssoLoginUrl;

    redirectUrl = redirectUrl + '?target=' + encodeURI(returnUrl);

    window.location.replace(redirectUrl);
  }

  async redirectAndLogout(returnUrl: string) {
    localStorage.clear();

    // wait for the promise to resolve
    let redirectUrl = this.configuration.ssoLogoutUrl;

    redirectUrl = redirectUrl + '?return=' + encodeURI(returnUrl);

    window.location.replace(redirectUrl);
  }

  hasReadOnlyRole(): boolean {
    let userProfile: UserProfileDto = this.currentUserProfile();
    if (userProfile != null &&
      userProfile.accesses != undefined &&
      userProfile.accesses.length > 0 &&
      userProfile.accesses.findIndex(access => access.roleVldID === RoleVldDto.Type.DivisionAdministrator || access.roleVldID === RoleVldDto.Type.DepartmentCountEditor) >=0) {
      return false;
    }

    return true;
  }

  hasEditorRole(): boolean {
    let userProfile: UserProfileDto = this.currentUserProfile();
    if (userProfile != null &&
      userProfile.accesses != undefined &&
      userProfile.accesses.length > 0 &&
      userProfile.accesses.findIndex(access => access.roleVldID === RoleVldDto.Type.DepartmentCountEditor) >= 0) {
      return true;
    }

    return false;
  }

  isAgencyUser(): boolean {
    let userProfile: UserProfileDto = this.currentUserProfile();
    if (userProfile != null) {
      if (userProfile.formUserProfileType == UserProfileTypeListItem.AgencyUser) {
        return true;
      }
    }

    return false;
  }


  editableDepartments(): string[] {
    let userProfile: UserProfileDto = this.currentUserProfile();

    // Get most restrictive role
    let departmentIds: string[] = [];
    if (userProfile != null) {
      for (var i = 0; i < userProfile.accesses.length; i++) {
        var access = userProfile.accesses[i];
        if (access.departmentID != null &&
          departmentIds.findIndex(id => id === access.departmentID) <= 0 &&
          access.roleVldID === 2) {
          departmentIds.push(access.departmentID);
        }
      }
    }

    return departmentIds;
  }

  explicitlyAuthorizedDepartments(): string[] {
    let userProfile: UserProfileDto = this.currentUserProfile();

    // Get most restrictive role
    let departmentOrAgencyIds: string[] = [];
    if (userProfile != null) {
      for (var i = 0; i < userProfile.accesses.length; i++) {
        var access = userProfile.accesses[i];
        if (access.departmentID != null && departmentOrAgencyIds.findIndex(id => id === access.departmentID) >= 0) {
          departmentOrAgencyIds.push(access.departmentID);
        }
      }
    }

    return departmentOrAgencyIds;
  }

  explicitlyAuthorizedAgencies(): string[] {
    let userProfile: UserProfileDto = this.currentUserProfile();

    // Get most restrictive role
    let departmentOrAgencyIds: string[] = [];
    if (userProfile != null) {
      for (var i = 0; i < userProfile.accesses.length; i++) {
        var access = userProfile.accesses[i];
        if (access.agencyID != null && departmentOrAgencyIds.findIndex(id => id === access.agencyID) >= 0) {
          departmentOrAgencyIds.push(access.agencyID);
        }
      }
    }

    return departmentOrAgencyIds;
  }

  constructor(private router: Router, private securityEndpoint: SecurityEndpoint, private configuration: ConfigurationService) {

  }

  async checkAuthorization() {
  
    let webSiteMode = this.configuration.getExternalWebsiteMode;
   //// localStorage.clear();
    if (webSiteMode == "yes") {
      //// MyAlbertaID call commented
      ////await this.checkAuthorizationExternal(); 
    } else {
      await this.checkAuthorizationInternal();
    }
  }

  async checkAuthorizationInternal() {
  
    
    let promiseGetUserProfileValue = new Promise((resolve, reject) => {
      this.securityEndpoint.getLoggedInUserProfile().subscribe(userProfileValue => {
        resolve(userProfileValue);
      });
    });

    // wait for the promise to resolve
    let getUserProfileValue = await promiseGetUserProfileValue as UserProfileDto;
    localStorage.removeItem(this.currentUserProfileItemKey);
    localStorage.setItem(this.currentUserProfileItemKey, JSON.stringify(getUserProfileValue));
  }

  async checkAuthorizationExternal() {
    localStorage.removeItem(this.myAlbertaIdPropertiesKey);
    localStorage.removeItem(this.currentUserProfileItemKey);

    let promiseGetMadiAuthValue = new Promise((resolve, reject) => {
      this.securityEndpoint.getMadiPropertiesEndpoint().subscribe(madiAuthValue => {
        resolve(madiAuthValue);
      });
    });

    // wait for the promise to resolve
    let getMadiAuthValue = await promiseGetMadiAuthValue as MadiAuthenticationDto;

    localStorage.setItem(this.myAlbertaIdPropertiesKey, JSON.stringify(getMadiAuthValue));

    let promiseGetUserProfileValue = new Promise((resolve, reject) => {
      this.securityEndpoint.getUserProfileByExternalLoginId(getMadiAuthValue.persistentId).subscribe(userProfileValue => {
        resolve(userProfileValue);
      });
    });

    // wait for the promise to resolve
    let getUserProfileValue = await promiseGetUserProfileValue as UserProfileDto;

    localStorage.setItem(this.currentUserProfileItemKey, JSON.stringify(getUserProfileValue));

    
  }

  async validateRoute(url: string) {
    //For User Membership
    const isLoginForm = url === '/login-form';
    ////console.log(this.isAuthorized());
    if (!this.isAuthorized() && !isLoginForm) {
      this.router.navigate(['/login-form']);
    }

    let promiseAuthorization = new Promise((resolve, reject) => {
      this.checkAuthorization().then(() => {
        resolve(true);
      });
    });

    //// wait for the promise to resolve
    let getAuthorizationStatus = await promiseAuthorization;

    switch (url) {
      case "/loginStatus":
      case "/ChangePassword":
      case "/ManageCount":
      case "/Permit":
      case "/PermitDetail":
      case "/PermitDetail/:id":
      case "/Reports":
      case "/Faq":
      case "/ManageCountDetail":
      case "/UserAccess":
      case "/UserAccessDetail/:id":
      case "/UserAccessDetail":
      case "/ManageCountDetail/:id":
        if (this.isAuthorized()) {
          return true;
        }
        break;
    default:
      return true;
    }
  }

  getLevelOfAccessForRegulatoryItem(regulatoryItemId: string) {
    let userProfile: UserProfileDto = this.currentUserProfile();

    if (userProfile != null) {
      // wait for the promise to resolve
      return this.securityEndpoint.getRoleForRegulatoryItem(userProfile.userProfileID, regulatoryItemId);
    }

    return null;
  }

  submitUserProfileRequest(userProfileRequest: UserProfileRequestDto) {
    return this.securityEndpoint.submitUserProfileRequest<BusinessRuleMessage[]>(userProfileRequest);
  }

  async logIn(userLogin: UserLoginDto) {

    let promiseGetUserProfileValue = new Promise((resolve, reject) => {
      this.securityEndpoint.logIn(userLogin).subscribe(userProfileValue => {
        resolve(userProfileValue);
      });
    });

    // wait for the promise to resolve
    let getUserProfileValue = await promiseGetUserProfileValue as UserProfileDto;
    if (getUserProfileValue != null) {
      localStorage.removeItem(this.currentUserProfileItemKey);
      localStorage.setItem(this.currentUserProfileItemKey, JSON.stringify(getUserProfileValue));

      if (getUserProfileValue.isFirstTimeLogin) {
        this.router.navigate(['/ChangePassword']);
      }
      else if (!getUserProfileValue.isActive || getUserProfileValue.membershipProviderIsLockedOut) {
        return;
      }
      else if (!getUserProfileValue.isValidLogin) {
        localStorage.clear();
        return;
      }
      else{
        this.router.navigate(['/']);
      }
      
    }
  }

  async logOut() {
    localStorage.removeItem(this.currentUserProfileItemKey);
    localStorage.clear();
    this.router.navigate(['/login-form']);
  }

  resetPassword(emailAddress: string) {
    return this.securityEndpoint.resetPassword<boolean>(emailAddress);
  }

  validatePassword(userLogin: UserLoginDto) {
    return this.securityEndpoint.validatePassword(userLogin);
  }

  changePassword(userLogin: UserLoginDto) {
    return this.securityEndpoint.changePassword(userLogin);
  }

  unlockWebAccount(emailAddress: string) {
    return this.securityEndpoint.unlockWebAccount<boolean>(emailAddress);
  }

  checkAccessPermission(resource: string, action?: Actions, departmentId?: string, agencyId?: string) {

    let userProfile: UserProfileDto = this.currentUserProfile();
    
    if (userProfile != null) {
      if (this.hasAdministratorRole()) {
        departmentId = null;
      }
     
      var access = userProfile.accesses.find(d => d.departmentID == departmentId);

      //Check if the agency exists
      if (access == null) {
        var access = userProfile.accesses.find(d => d.agencyID == agencyId);
      }

      if (access != null) {
        var rolePermissionVlds = access.roleVld.rolePermissionVlds;
        if (action != null) {
          if (rolePermissionVlds.findIndex(i => i.resource === resource && i.action === action) >= 0) {
            return true;
          }
        } else {
          if (rolePermissionVlds.findIndex(i => i.resource === resource) >= 0) {
            return true;
          }
        }
      }

     
    }
    return false;
  }

  checkAccessPermissionByApp(appId: number, resource: string, action?: Actions, departmentId?: string, agencyId?: string) {

    let userProfile: UserProfileDto = this.currentUserProfile();
   
    if (userProfile != null) {

      if (this.hasAdministratorRoleByApp(appId)) {
        departmentId = null;
        agencyId = null;
      }
     
      //Filter the accesses by app
      var userAccesses = userProfile.accesses.filter(a => a.roleVld.applicationVldID == appId);
      var access: any;
      
      if (departmentId != null || agencyId != null ) 
        access = userAccesses.find(d => d.departmentID == departmentId || d.agencyID == agencyId );
      else
        access = userAccesses[0];

     
      if (access != null) {
        var rolePermissionVlds = access.roleVld.rolePermissionVlds;
        if (action != null) {
          if (rolePermissionVlds.findIndex(i => i.resource === resource && i.action === action) >= 0) {
            return true;
          }
        } else {
          if (rolePermissionVlds.findIndex(i => i.resource === resource) >= 0) {
            return true;
          }
        }
      }


    }
    return false;
  }
}
